import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb26b47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chair-picker-container" }
const _hoisted_2 = { class: "chair-picker-inner-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chairs, (chair) => {
        return (_openBlock(), _createElementBlock("div", {
          key: chair.file
        }, [
          _createVNode(_component_router_link, {
            class: "chair-link",
            to: {name: 'Configurator', params: {id: chair.id}}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(chair.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128)),
      _createVNode(_component_router_link, {
        class: "chair-link",
        to: {name: 'Nido'}
      }, {
        default: _withCtx(() => [
          _createTextVNode("Nido")
        ]),
        _: 1
      })
    ])
  ]))
}